import _ from 'lodash';
import { createSelector } from 'reselect';

export const getModalScreen = state => _.get(state, 'profiles.modal.modal');
export const getModalState = state => _.get(state, 'profiles.modal.show');
export const getAddButtonState = state => {
  const maxMembers = _.get(state, 'profiles.profile.data.maxMembers');
  const members = getProfileMembers(state);
  if (members && members.length >= maxMembers) return true;
  return false;
};

export const getProfileMembers = state =>
  _.get(state, 'profiles.profile.data.members') || [];

export const getLoadingProfiles = state =>
  _.get(state, 'profiles.profile.loading');

export const getAvatars = state => _.get(state, 'profiles.avatars.data') || [];

export const getDefaultImage = createSelector(
  getAvatars,
  items => _.find(items, { default: true }),
);

export const getFormStatus = state => _.get(state, 'profiles.form.loading');

export const getFormSuccess = state => _.get(state, 'profiles.form.success');
export const getFormResponse = state =>
  _.get(state, 'profiles.form.response') ||
  _.get(state, 'profiles.avatars.response') ||
  _.get(state, 'profiles.profile.response');

export const getFormError = state =>
  _.get(state, 'profiles.form.error') ||
  _.get(state, 'profiles.avatars.error') ||
  _.get(state, 'profiles.profile.error');

export const getUser = state => _.get(state, 'user');

export const selectUserState = state => _.get(state, 'user');

export const getCurrentUserRole = createSelector(
  getUser,
  item => _.get(item, 'isAdmin'),
);

export const getGamificationId = createSelector(
  getUser,
  item => _.get(item, 'gamification_id'),
);
export const getUserToken = createSelector(
  getUser,
  item => _.get(item, 'token'),
);
export const getUserId = createSelector(
  getUser,
  item => _.get(item, 'user_id'),
);

export const getUserName = createSelector(
  getUser,
  item => _.get(item, 'username'),
);
export const getAdminUserId = createSelector(
  getProfileMembers,
  items => {
    const admin = _.find(items, { admin: true });
    return admin && admin.partnerUserId;
  },
);

export const getAdminHash = createSelector(
  getProfileMembers,
  items => _.get(_.find(items, { admin: true }), 'user_hash', ''),
);
